import { createActionGroup, props } from '@ngrx/store';
import { Grid } from '../../services/model/grid';

export const GridActions = createActionGroup({
  source: 'Grid Consultation',
  events: {
    'Grids Loaded': props<{ grids: Grid[] }>(),
    'Grid Loaded': props<{ grid: Grid }>(),
  },
});
